import React from "react";

import { Fade } from "react-awesome-reveal";

import heroPortfolio from "assets/images/hero/herooroduct.png";

export default function HeroPortfolio() {
  return (
    <section className="hero mb-0 items-center gap-6 sm:flex-row">
      <div className="mb-5 flex w-full flex-col px-5 sm:mb-0 sm:w-1/2 sm:px-12 sm:pt-6">
        <Fade direction="up" triggerOnce>
          <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-gold-700">Our Catalog</p>
          <h1 className="font-display text-5xl leading-tight text-maroon-900 sm:text-6xl">Products</h1>
        </Fade>
        <Fade direction="up" triggerOnce delay={200}>
          <p className="mt-4 max-w-md text-lg font-light leading-relaxed text-slate-500">
            From bulk packaging to bottled perfection — explore our full range of sauces
            and condiments tailored for your business needs.
          </p>
        </Fade>
      </div>
      <div className="w-full sm:w-1/2 sm:pr-12">
        <Fade direction="up" triggerOnce>
          <img
            src={heroPortfolio}
            alt="A display of VR Food Products sauce bottles"
            loading="eager"
            className="w-full"
          />
        </Fade>
      </div>
    </section>
  );
}
